var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { bind } from "decko";
import { Grid } from "../grid/grid";
import { GridItem } from "../grid/griditem";
import { css, cx } from "emotion";
const dropzoneClass = css({
    display: "contents",
});
const overlayClass = css({
    backgroundColor: "#fffa",
    zIndex: 1,
    alignContent: "center",
    justifyContent: "center",
    pointerEvents: "none",
    display: "grid",
});
export class FileDropzone extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasDragOver: false,
        };
    }
    onDropHandler(e) {
        e.preventDefault();
        this.setState({ hasDragOver: false });
        if (e.dataTransfer.items) {
            const droppedFiles = [];
            for (var _i = 0; _i < e.dataTransfer.items.length; _i++) {
                const tmpFile = e.dataTransfer.items[_i].getAsFile();
                tmpFile && droppedFiles.push(tmpFile);
            }
            this.props.onDrop && this.props.onDrop(droppedFiles);
            e.dataTransfer.items.clear();
        }
        else {
            e.dataTransfer.clearData();
        }
    }
    onDragOver(e) {
        e.preventDefault();
        this.setState({ hasDragOver: true });
    }
    onDragLeave() {
        this.setState({ hasDragOver: false });
    }
    render() {
        return (React.createElement("div", { className: cx(dropzoneClass), onDrop: this.onDropHandler, onDragOver: this.onDragOver, onDragLeave: this.onDragLeave, onDragEnd: () => this.setState({ hasDragOver: false }) },
            React.createElement(Grid, { columns: 1, height: this.props.height },
                React.createElement(GridItem, { rowStart: 1, colStart: 1, minHeight: 0 }, this.props.children),
                this.state.hasDragOver && this.props.overlay && (React.createElement("div", { className: cx(overlayClass), style: { gridArea: "1 / 1 / auto / auto" } },
                    React.createElement("div", { className: cx(overlayClass) }, this.props.overlay))))));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FileDropzone.prototype, "onDropHandler", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FileDropzone.prototype, "onDragOver", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FileDropzone.prototype, "onDragLeave", null);
export default FileDropzone;
//# sourceMappingURL=filedropzone.js.map